import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CalendarIcon from "../../Assets/img/calendar.png";

import "./News.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Loading from "../../Loading/loading";
import API from "../Service/Baseservice";

const NewsView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const news = location.state?.news;
    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState([]);
    const page = location.state?.page || 1;
    const fetchCategories = () => {
        API.post("newscategory_list/condition", {})
            .then((res) => {
                const categoryData = res?.data?.data?.data || [];
                const activeCategories = categoryData.filter(
                    (cat) => cat.active === 1 || cat.active === "1"
                );
                setCategories(activeCategories);
            })
            .catch((err) => console.error("Failed to fetch categories:", err))
            .finally(() => setLoading(false));
    };
    const [formData, setFormData] = useState({
        language_id: 1,
        heading: "",
        description: "",
        date: "",
        status: "active",
        createdBy: 1,
        updatedBy: 1,
        active: 1,
        newscategory_id: "",
    });

    useEffect(() => {
        if (news) {
            setFormData({
                language_id: news.language_id || 1,
                heading: news.heading || "",
                description: news.description || "",
                date: news.date || "",
                status: news.status || "active",
                createdBy: news.createdBy || 1,
                updatedBy: news.updatedBy || 1,
                active: news.active || 1,
                newscategory_id: news.newscategory_id?.toString(),
            });

            fetchCategories();
            setLoading(false);
        } else {
            alert("No news data found. Redirecting...");
            navigate("/news");
        }
    }, [news, navigate]);

    if (loading) return <Loading />;

    const categoryName =
        categories.find(
            (cat) => cat.newscategory_id?.toString() === formData.newscategory_id
        )?.category_name || "Unknown";

    return (
        <div className="newss-containeradd">
            <div className="newssadd-container">
                <div className="newsadd-header">
                    <h2 className="newssadd-title">View News</h2>
                    <div className="header-buttons">
                        <button onClick={() => navigate("/news", { state: { page } })} className="cancel-btn ">
                            Back
                        </button>
                    </div>
                </div>

                <div className="newssadd-formcard">
                    <div className="news-form-items">
                        <div className="news-row">

                            <div className="news-form-group" style={{ flex: 1 }}>
                                <label>Category</label>
                                <input
                                    type="text"
                                    value={categoryName}
                                    readOnly
                                    className="readonly-input"
                                />
                            </div>


                            <div className="news-form-group" style={{ flex: 1 }}>
                                <label>Date</label>
                                <div className="news-date-wrapper">
                                    <input
                                        type="date"
                                        name="date"
                                        value={formData.date}
                                        readOnly
                                        className={formData.date ? "has-value" : ""}
                                        style={{ backgroundColor: "#f9f9f9", cursor: "not-allowed" }}
                                    />
                                    <img
                                        src={CalendarIcon}
                                        alt="Calendar"
                                        className="news-calendar-icon"
                                    />
                                </div>
                            </div>
                        </div>


                        <div className="news-form-group">
                            <label className="news-description-label">Heading</label>
                            <input
                                type="text"
                                name="heading"
                                placeholder="Enter your text here...."
                                value={formData.heading}
                                readOnly
                            />
                        </div>

                        <div className="news-form-group">
                            <label>Description</label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={formData.description}
                                disabled={true}
                                // config={{ toolbar: [] }}
                                className="description1-editor"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsView;
